import { createAllActions } from '@api/createRequestStore';
import * as types from './types';

export const init = () => ({
  type: types.INIT,
});

const { init: initRequest, fetching } = createAllActions(types.SCOPE);

export { initRequest, fetching };
